import { NaniumObject, Type } from 'nanium/objects';

export class AuthorizedUpload extends NaniumObject<AuthorizedUpload> {
	@Type(String) secret: string;
	@Type(Date) creationDate: Date;
	@Type(String) requestorAccountId: string;
	@Type(String) fileField: string;
	@Type(String) fileLabel: string;
	@Type(String) description?: string;
	@Type(Number) maxFileSize?: number;
	@Type(Array, String) fileTypes?: string[];
	@Type(Boolean) sendRequestorMailOnUpload?: boolean;
}
